import {Box,Flex,Text,Image,VStack,Heading,SimpleGrid,Icon,HStack,Grid,Link} from "@chakra-ui/react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import image1 from '../images/logo.png'
import image2 from '../images/image6.jpg'
import image3 from '../images/image7.jpg'
import image4 from '../images/image8.jpg'
import Header from "../utils/header";
import Footer from "../utils/footer";
import { AnimatedComponent } from "../utils/utils";

export default function AboutUsPage() {
  return (
    <Box>
        <Header/>
        <Box bg="gray.50" color="gray.700" py={16} px={{ base: 3, md: 10 }} boxShadow="2xl">
            {/* Logo & Intro */}
            <Box bg="gray.200" py={10} borderTopRadius={20}>
                <Flex px={{ base: 3, md: 10 }} direction={{ base: "column", md: "row" }} align="center">
                    <AnimatedComponent delay={.5}>
                        <Image
                            src={image1}
                            alt="Ikhlas Bangun Griya Logo"
                            boxSize={{ base: "150px", md: "200px" }}
                            objectFit="contain"
                            mr={{ md: 10 }}
                        />
                    </AnimatedComponent>
                    <VStack align="start" spacing={4}>
                        <AnimatedComponent delay={.5}>
                            <Heading size="2xl" fontWeight="bold" color="blue.500">
                                PT. Ikhlas Bangun Griya Construction
                            </Heading>
                        </AnimatedComponent>
                        <AnimatedComponent delay={.5}>
                            <Text fontSize={{base:"sm", md:"md"}}>
                                Berdiri sejak <strong>24 Mei 2025</strong>, kami berkomitmen untuk
                                menghadirkan hasil konstruksi yang <strong>berkualitas tinggi</strong>,
                                berlandaskan <strong>keikhlasan, profesionalisme, dan tanggung jawab</strong>.
                            </Text>
                        </AnimatedComponent>
                    </VStack>
                </Flex>
            </Box>

            {/* Filosofi Logo */}
            <Box bgImage={`url(${image2})`}>
                <Box py={16} px={{ base: 3, md: 10 }} bgColor="green.600/90" color="white" borderBottomWidth={10} borderBottomColor="green.700">
                    <AnimatedComponent delay={.5}>
                        <Heading size="2xl" color="yellow.300" mb={4}>
                            Filosofi Logo
                        </Heading>
                    </AnimatedComponent>
                    <AnimatedComponent delay={.5}>
                        <Text mb={4}>
                            <strong>Ikhlas (Integritas):</strong> Elemen rumah kokoh yang saling terhubung
                            melambangkan niat tulus dan tanggung jawab dalam setiap pembangunan.
                        </Text>
                    </AnimatedComponent>
                    <AnimatedComponent delay={.5}>
                        <Text mb={4}>
                            <strong>Bangun (Stabilitas):</strong> Bentuk geometris terstruktur mencerminkan
                            profesionalisme, kekuatan, dan pondasi yang kokoh.
                        </Text>
                    </AnimatedComponent>
                    <AnimatedComponent delay={.5}>
                        <Text>
                            <strong>Griya (Pertumbuhan):</strong> Atap hijau melambangkan pertumbuhan, harmoni,
                            dan kehidupan yang seimbang dengan lingkungan.
                        </Text>
                    </AnimatedComponent>
                </Box>
            </Box>

            {/* Profil Perusahaan */}
            <Box py={16} bg="gray.200" px={{ base: 3, md: 10 }}>
                <AnimatedComponent delay={.5}>
                    <Heading size="2xl" color="blue.500" mb={4} textAlign={"center"}>
                        Profil Perusahaan
                    </Heading>
                </AnimatedComponent>
                <AnimatedComponent delay={.5}>
                    <Text>
                        <strong>Ikhlas Bangun Griya</strong> adalah perusahaan jasa konstruksi
                        yang berlandaskan nilai <strong>keikhlasan dan kejujuran</strong>.
                        Kami membangun rumah, masjid, sekolah, dan fasilitas umum dengan
                        <strong> kualitas tinggi dan penuh tanggung jawab</strong>.  
                        Setiap karya kami adalah bentuk ibadah dan amal jariyah yang bermanfaat bagi masyarakat.
                    </Text>
                </AnimatedComponent>
            </Box>

            {/* Visi dan Misi */}
            <Box bgImage={`url(${image2})`}>
                <Box py={6} px={{ base: 3, md: 10 }} display={{base:"none",md:"block"}} bg="blue.300/80" borderBottomWidth={10} borderBottomColor="blue.500">
                    <Grid templateColumns="49% 2% 49%" placeItems="center" gap="0">
                        <Box h="100%" w="100%" bgImage={`url(${image3})`} borderLeftRadius={20}>
                            <Box py={10} h="100%" w="100%" color={"white"}  bgColor="blue.500/90" borderLeftRadius={20} px={{ base: 3, md: 10 }}>
                                <AnimatedComponent delay={.5}>
                                    <Heading size="2xl" textAlign={"center"} color="yellow.300" mb={2} w={"100%"}>
                                        Visi
                                    </Heading>
                                </AnimatedComponent>
                                <AnimatedComponent delay={.5}>
                                    <Text>Menjadi perusahaan konstruksi terkemuka di Indonesia yang dikenal karena kualitas, inovasi, dan kepuasan konsumen.</Text>
                                </AnimatedComponent>
                            </Box>
                        </Box>
                        <Box orientation="vertical" h="100%" w="100%" bgColor="yellow.300"/>
                        <Box h="100%" w="100%" bgImage={`url(${image4})`} borderRightRadius={20}>
                            <Box py={10} h="100%" w="100%" color={"white"} bgColor="blue.800/90" borderRightRadius={20} px={{ base: 3, md: 10 }}>
                                <AnimatedComponent delay={.5}>
                                    <Heading size="2xl" textAlign={"center"} color="yellow.300" mb={2} w={"100%"}>
                                        Misi
                                    </Heading>
                                </AnimatedComponent>
                                <AnimatedComponent delay={.5}>
                                    <Box pl={4}>
                                        <Text>• Menyediakan solusi konstruksi inovatif dan berkualitas tinggi</Text>
                                        <Text>• Membangun citra perusahaan yang terpercaya dan berpengalaman</Text>
                                        <Text>• Mengutamakan kepuasan konsumen</Text>
                                        <Text>• Memberikan layanan cepat dan responsif selama 24 jam</Text>
                                    </Box>
                                </AnimatedComponent>
                            </Box>
                        </Box>
                    </Grid>
                </Box>
                <Box py={6} px={{ base: 3, md: 10 }} display={{base:"block",md:"none"}} bg="blue.300/80">
                    <Flex direction="column">
                        <Box h="100%" w="100%" bgImage={`url(${image3})`} borderTopRadius={20}>
                            <Box py={10} h="100%" color={"white"}  bgColor="blue.500/90" borderTopRadius={20} px={{ base: 3, md: 10 }}>
                                <AnimatedComponent delay={.5}>
                                    <Heading size="2xl" textAlign={"center"} color="yellow.300" mb={2} w={"100%"}>
                                        Visi
                                    </Heading>
                                </AnimatedComponent>
                                <AnimatedComponent delay={.5}>
                                    <Text>Menjadi perusahaan konstruksi terkemuka di Indonesia yang dikenal karena kualitas, inovasi, dan kepuasan konsumen.</Text>
                                </AnimatedComponent>
                            </Box>
                        </Box>
                        <Box orientation="vertical" h="5px" w="100%" bgColor="yellow.300"/>
                        <Box h="100%" w="100%" bgImage={`url(${image4})`} borderBottomRadius={20}>
                            <Box py={10} h="100%" color={"white"} bgColor="blue.800/90" borderBottomRadius={20} px={{ base: 3, md: 10 }}>
                                <AnimatedComponent delay={.5}>
                                    <Heading size="2xl" textAlign={"center"} color="yellow.300" mb={2} w={"100%"}>
                                        Misi
                                    </Heading>
                                </AnimatedComponent>
                                <AnimatedComponent delay={.5}>
                                    <Box pl={4}>
                                        <Text>• Menyediakan solusi konstruksi inovatif dan berkualitas tinggi</Text>
                                        <Text>• Membangun citra perusahaan yang terpercaya dan berpengalaman</Text>
                                        <Text>• Mengutamakan kepuasan konsumen</Text>
                                        <Text>• Memberikan layanan cepat dan responsif selama 24 jam</Text>
                                    </Box>
                                </AnimatedComponent>
                            </Box>
                        </Box>
                    </Flex>
                </Box>
            </Box>

            {/* Keunggulan Pelayanan */}
            <Box py={16} bg="gray.200" px={{ base: 3, md: 10 }}>
                <AnimatedComponent delay={.5}>
                    <Heading size="2xl" color="blue.500" mb={4} textAlign={"center"}>
                        Keunggulan Kami
                    </Heading>
                </AnimatedComponent>
                <SimpleGrid columns={{ base: 1, md: 2 }} gap={2}>
                    <AnimatedComponent delay={.5}>
                        <Box bg="white" p={5} rounded="xl" shadow="md">
                            <Text>✅ Menyesuaikan Budget dan Kebutuhan Klien</Text>
                        </Box>
                    </AnimatedComponent>
                    <AnimatedComponent delay={.5}>
                        <Box bg="white" p={5} rounded="xl" shadow="md">
                            <Text>✅ Tim Profesional dan Berpengalaman</Text>
                        </Box>
                    </AnimatedComponent>
                    <AnimatedComponent delay={.5}>
                        <Box bg="white" p={5} rounded="xl" shadow="md">
                            <Text>✅ Layanan Fleksibel dan Responsif</Text>
                        </Box>
                    </AnimatedComponent>
                    <AnimatedComponent delay={.5}>
                        <Box bg="white" p={5} rounded="xl" shadow="md">
                            <Text>✅ Komitmen Terhadap Kualitas dan Ketepatan Waktu</Text>
                        </Box>
                    </AnimatedComponent>
                </SimpleGrid>
            </Box>

            {/* Layanan */}
            <Box bgImage={`url(${image2})`}>
                <Box py={16} px={{ base: 3, md: 10 }} bgColor="green.600/90" borderBottomWidth={10} borderBottomColor="green.700">
                    <AnimatedComponent delay={.5}>
                        <Heading size="2xl" color="yellow.300" mb={4}>
                            Layanan Kami
                        </Heading>
                    </AnimatedComponent>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={2} mb={5}>
                        <AnimatedComponent delay={.5}>
                            <Box bgImage={`url(${image3})`} rounded="xl">
                                <Box p={5} bg="green.700/80" color={"white"} rounded="xl" shadow="sm">
                                    <Text fontWeight="bold">🏗️ Konstruksi Bangunan Gedung</Text>
                                </Box>
                            </Box>
                        </AnimatedComponent>
                        <AnimatedComponent delay={.5}>
                            <Box bgImage={`url(${image4})`} rounded="xl">
                                <Box p={5} bg="green.300/80" rounded="xl" shadow="sm">
                                    <Text fontWeight="bold">🏭 Konstruksi Industri</Text>
                                </Box>
                            </Box>
                        </AnimatedComponent>
                        <AnimatedComponent delay={.5}>
                            <Box bgImage={`url(${image4})`} rounded="xl">
                                <Box p={5} bg="green.300/80" rounded="xl" shadow="sm">
                                    <Text fontWeight="bold">🔧 Renovasi & Perbaikan Rumah / Ruko</Text>
                                </Box>
                            </Box>
                        </AnimatedComponent>
                        <AnimatedComponent delay={.5}>
                            <Box bgImage={`url(${image3})`} rounded="xl">
                                <Box p={5} bg="green.700/80" color={"white"} rounded="xl" shadow="sm">
                                    <Text fontWeight="bold">📐 Desain & Perencanaan Konstruksi</Text>
                                </Box>
                            </Box>
                        </AnimatedComponent>
                    </SimpleGrid>
                    <Flex w="100%" justify={"end"}>
                        <Link href="/service" color="blue.200" isExternal>
                            {">>> pelajari lebih lanjut"}
                        </Link>
                    </Flex>
                </Box>
            </Box>

            {/* Kontak */}
            <Box py={10} bg="gray.200" px={{ base: 3, md: 10 }} borderBottomRadius={20}>
                <AnimatedComponent delay={.5}>
                    <Heading size="2xl" color="blue.600" mb={4} textAlign={"center"}>
                        Hubungi Kami
                    </Heading>
                </AnimatedComponent>
                <VStack align="center" gap={3}>
                    <Box>
                        <AnimatedComponent delay={.5}>
                            <HStack align="center" w={"inherit"} gap={5}>
                                <Icon as={FaPhone} color="green.500" />
                                <Box>
                                    <Text><strong>Admin 1: </strong>0882008354419</Text>
                                    <Text><strong>Admin 2: </strong> 08988684379</Text>
                                </Box>
                            </HStack>
                        </AnimatedComponent>
                        <AnimatedComponent delay={.5}>
                            <HStack align="center" gap={5}>
                                <Icon as={FaEnvelope} color="blue.500" />
                                <Text>ikhlasbangungriya@gmail.com</Text>
                            </HStack>
                        </AnimatedComponent>
                        <AnimatedComponent delay={.5}>
                            <HStack align="center" gap={5}>
                                <Icon as={FaMapMarkerAlt} color="red.500" mt={1} />
                                <Box>
                                    <Text><strong>Kantor 1:</strong> Jln. Gadjah Mada No.42, Bolon, Colomadu, Karanganyar</Text>
                                    <Text><strong>Kantor 2:</strong> Ds Ngembes 01/03, Punduhsari, Manyaran, Wonogiri</Text>
                                </Box>
                            </HStack>
                        </AnimatedComponent>
                    </Box>
                </VStack>
            </Box>
        </Box>
        <Footer/>
    </Box>
  );
}
